import withTryCatch from './withTryCatch';

/**
 * Abbreviates numbers larger than 999 with suffix and rounded to one decimal
 *
 * @param {number} wholeNumber - number to be shortened
 * @returns {*} number if smaller than 1000 and string if greater than 999
 *
 * @example
 *     const updatedNumber = abbreviateLargeNumber(22400)
 *     -> 22.4K
 */

const abbreviateLargeNumber = (wholeNumber: number): string => {
  let abbreviationLetter;
  let number = wholeNumber;
  const roundsToAtLeastOneMillion = number >= 10 ** 6 - 50;
  const greaterThanOneThousand = number >= 10 ** 3;

  if (roundsToAtLeastOneMillion) {
    abbreviationLetter = 'M';
    number /= 10 ** 6;
  } else if (greaterThanOneThousand) {
    abbreviationLetter = 'K';
    number /= 10 ** 3;
  }

  const numberRoundedToOneDecimal = Math.round(number * 10) / 10;

  return abbreviationLetter
    ? `${numberRoundedToOneDecimal}${abbreviationLetter}`
    : String(numberRoundedToOneDecimal);
};

const abbreviateLargeNumberWrapper = (num: number | string) =>
  withTryCatch(abbreviateLargeNumber, String(num), num);

export default abbreviateLargeNumberWrapper;
